// Preferências de quem está usando o computador — tamanho do texto e tema.
// Vivem em localStorage, não no banco: são escolhas de acessibilidade da
// pessoa naquele navegador, não dados do escritório.

const CHAVE_ESCALA = '@SeloJuridico:escalaInterface';
const ESCALA_PADRAO = 1;

export const ESCALAS_DISPONIVEIS = [
    { valor: 0.9, rotulo: 'Pequeno' },
    { valor: 1, rotulo: 'Normal' },
    { valor: 1.2, rotulo: 'Grande' },
    { valor: 1.4, rotulo: 'Extra grande' }
];

export function lerEscalaInterface() {
    const valor = Number(localStorage.getItem(CHAVE_ESCALA));
    return ESCALAS_DISPONIVEIS.some((e) => e.valor === valor) ? valor : ESCALA_PADRAO;
}

// Implementado via `zoom` (não font-size no <html>) de propósito: o design
// system usa `px` fixo em vários lugares, então escalar só a fonte raiz não
// afetaria nada disso. `zoom` escala a página inteira de forma uniforme.
export function aplicarEscalaInterface(escala) {
    document.documentElement.style.setProperty('zoom', String(escala));
    localStorage.setItem(CHAVE_ESCALA, String(escala));
}

const CHAVE_TEMA = '@SeloJuridico:tema';

export const TEMAS_DISPONIVEIS = [
    { valor: 'claro', rotulo: 'Claro' },
    { valor: 'escuro', rotulo: 'Escuro' },
    { valor: 'sistema', rotulo: 'Sistema' }
];

export function lerTema() {
    const valor = localStorage.getItem(CHAVE_TEMA);
    return valor === 'claro' || valor === 'escuro' ? valor : 'sistema';
}

// 'sistema' remove o atributo e deixa a media query decidir; 'claro'/'escuro'
// força via [data-theme], que tem especificidade maior e vence nos dois sentidos.
export function aplicarTema(tema) {
    if (tema === 'sistema') {
        document.documentElement.removeAttribute('data-theme');
    } else {
        document.documentElement.setAttribute('data-theme', tema === 'claro' ? 'light' : 'dark');
    }
    localStorage.setItem(CHAVE_TEMA, tema);
}

/* ----------------------------------------------------------------------
   Densidade das tabelas — "confortável" (padrão) ou "compacto" para caber
   mais linhas por tela. Aplicado via data-densidade no <html>; o CSS aperta
   o padding das células. Preferência do navegador, como tema e escala.
   ---------------------------------------------------------------------- */
const CHAVE_DENSIDADE = '@SeloJuridico:densidade';

export const DENSIDADES_DISPONIVEIS = [
    { valor: 'confortavel', rotulo: 'Confortável' },
    { valor: 'compacto', rotulo: 'Compacto' }
];

export function lerDensidade() {
    const v = localStorage.getItem(CHAVE_DENSIDADE);
    return v === 'compacto' ? 'compacto' : 'confortavel';
}

export function aplicarDensidade(densidade) {
    document.documentElement.setAttribute('data-densidade', densidade);
    localStorage.setItem(CHAVE_DENSIDADE, densidade);
}

/* ----------------------------------------------------------------------
   Fonte — "padrao" (Archivo, sans) ou "serifada" (Lora no corpo). Muitos
   advogados acham a serifada mais séria e legível em texto longo. Aplicado
   via data-fonte no <html>, que troca as variáveis de fonte.
   ---------------------------------------------------------------------- */
const CHAVE_FONTE = '@SeloJuridico:fonte';

export const FONTES_DISPONIVEIS = [
    { valor: 'padrao', rotulo: 'Padrão (sem serifa)' },
    { valor: 'serifada', rotulo: 'Serifada' }
];

export function lerFonte() {
    const v = localStorage.getItem(CHAVE_FONTE);
    return v === 'serifada' ? 'serifada' : 'padrao';
}

export function aplicarFonte(fonte) {
    document.documentElement.setAttribute('data-fonte', fonte);
    localStorage.setItem(CHAVE_FONTE, fonte);
}

/* ----------------------------------------------------------------------
   Contraste — "normal" ou "alto". O alto contraste escurece o texto,
   reforça as bordas e reduz o esmaecimento dos textos de apoio, para quem
   tem baixa visão. Aplicado via data-contraste no <html>.
   ---------------------------------------------------------------------- */
const CHAVE_CONTRASTE = '@SeloJuridico:contraste';

export const CONTRASTES_DISPONIVEIS = [
    { valor: 'normal', rotulo: 'Normal' },
    { valor: 'alto', rotulo: 'Alto contraste' }
];

export function lerContraste() {
    const v = localStorage.getItem(CHAVE_CONTRASTE);
    return v === 'alto' ? 'alto' : 'normal';
}

export function aplicarContraste(contraste) {
    document.documentElement.setAttribute('data-contraste', contraste);
    localStorage.setItem(CHAVE_CONTRASTE, contraste);
}

/** Reaplica as preferências salvas — chamado uma vez ao carregar o app */
export function aplicarPreferenciasSalvas() {
    aplicarEscalaInterface(lerEscalaInterface());
    aplicarTema(lerTema());
    aplicarDensidade(lerDensidade());
    aplicarFonte(lerFonte());
    aplicarContraste(lerContraste());
}
